module.exports = __webpack_public_path__ + "img/logoWhite.6d9add75.svg";